import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
// ...existing code...
import TextField from '@material-ui/core/TextField';
import { formatDate } from '../utils/Format';
import "../table.css";

const headCells = [
    { id: 'groupInfoId', fid: 'groupInfoId', numeric: false, disablePadding: true, label: 'Portal User Group ID', filterLable: ' Group ID', width: '10rem', sortable: true },
    { id: 'groupTypeCd', fid: 'groupTypeCd', numeric: false, disablePadding: true, label: 'Group Type', filterLable: ' Group Type', width: '8rem', sortable: true },
    { id: 'statusCd', fid: 'statusCd', numeric: false, disablePadding: true, label: 'Group Status', filterLable: ' Status', width: '8rem', sortable: true },
    { id: 'createdDate', fid: 'createdDate', numeric: false, disablePadding: true, label: 'Create Date', filterLable: ' Create Date', width: '8rem', sortable: true },
    { id: 'actions', fid: 'actions', numeric: false, disablePadding: true, label: 'Actions', filterLable: ' Actions', width: '10rem', sortable: false }
];

function desc(a, b, orderBy) {
    let c = a[orderBy];
    let d = b[orderBy];

    if (c !== undefined && c !== null) {
        if (typeof c === "string") {
            c = c.toUpperCase();
        }
    } else {
        c = "";
    }

    if (d !== undefined && d !== null) {
        if (typeof d === "string") {
            d = d.toUpperCase();
        }
    } else {
        d = "";
    }

    if (d < c) {
        return -1;
    }

    if (d > c) {
        return 1;
    }

    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, onRequestFilter } = props;
    
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    
    const onFilter = property => event => {
        onRequestFilter(event.target.value, property);
    };

    return (
        <TableHead className={classes.tableHead}>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align="left"
                        padding="default"
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{ width: headCell.width, fontWeight: 'bold' }}
                    >
                        {headCell.sortable ? (
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={order}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        ) : (
                            headCell.label
                        )}
                    </TableCell>
                ))}
            </TableRow>
            <TableRow className="filter-row">
                {headCells.map(headCell => (
                    <TableCell 
                        key={headCell.id + '-filter'} 
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        style={{ maxWidth: headCell.width, paddingBottom:0}}
                    >
                        {headCell.sortable && (
                            <TextField
                                id={headCell.id + '-filter-input'}
                                placeholder={"Filter ..."}
                                fullWidth
                                style={{height:'.7'}}
                                margin="dense"
                                variant="outlined"
                                onChange={onFilter(headCell.fid)}
                            />
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onRequestFilter: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired
};

const useStyles1 = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = event => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = event => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    paginationTop: {
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableHead: {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
    },
    // textField: {
    //     width: '90%',
    //     marginLeft: theme.spacing(1),
    //     marginRight: theme.spacing(1),
    // }
});

class ManageGroupsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'groupInfoId',
            page: 0,
            rowsPerPage: 10,
            filteredGroups: props.groups
        };
    }

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({
            order: isDesc ? 'asc' : 'desc',
            orderBy: property
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    handleFilter = (value, property) => {
        if (value === '') {
            this.setState({
                filteredGroups: this.props.groups
            });
        } else {
            const filteredGroups = this.props.groups.filter(group => {
                if (group[property] === null || group[property] === undefined) {
                    return false;
                }
                return String(group[property]).toLowerCase().includes(value.toLowerCase());
            });
            this.setState({
                filteredGroups: filteredGroups,
                page: 0
            });
        }
        
        // Call parent component's filter method if it exists
        if (this.props.setFilter) {
            this.props.setFilter(this.state.filteredGroups);
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.groups !== this.props.groups) {
            this.setState({
                filteredGroups: this.props.groups
            });
        }
    }

    render() {
        const { classes, groups } = this.props;
        const { order, orderBy, page, rowsPerPage, filteredGroups } = this.state;

        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TablePagination
                        className={classes.paginationTop}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={filteredGroups.length}
                        rowsPerPage={rowsPerPage}
                        page={page}                        
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                    <div className={classes.tableWrapper}>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size="small"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                onRequestFilter={this.handleFilter}
                            />
                            <TableBody>
                                {stableSort(filteredGroups, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((group, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={group.groupInfoId}
                                                style={{
                                                    padding: '5px 20px',
                                                    height: 25,
                                                    backgroundColor: index % 2 ? '#fafafa' : 'white'
                                                }}
                                            >
                                                <TableCell component="th" scope="row" size="small">
                                                    {group.groupInfoId}
                                                </TableCell>
                                                <TableCell size="small">{group.groupTypeCd === 'ROS' ? 'Roster Group' : group.groupTypeCd === 'PRV' ? 'Provider Group' : group.groupTypeCd}</TableCell>
                                                    <TableCell size="small">{
                                                        group.statusCd === 'ACTIV' ? 'Active'
                                                        : group.statusCd === 'INACT' ? 'Inactive'
                                                        : group.statusCd === 'LOCK' ? 'Locked'
                                                        : group.statusCd === 'DISABL' ? 'Disabled'
                                                        : group.statusCd === 'PEND' ? 'Pending'
                                                        : group.statusCd
                                                    }</TableCell>
                                                <TableCell size="small">{formatDate(group.createdDate)}</TableCell>
                                                    <TableCell size="small">
                                                        {group.groupTypeCd === 'ROS' ? (
                                                            <TextField
                                                                variant='outlined'
                                                                select
                                                                margin='dense'
                                                                style={{ minWidth: '7em' }}
                                                                label='Select'
                                                                onChange={(event) => {
                                                                    if (this.props.handleGroupAction) {
                                                                        this.props.handleGroupAction(group.groupInfoId, event.target.value);
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value='Manage Roster Hub Sources'>Manage Roster Hub Sources</MenuItem>
                                                            </TextField>
                                                        ) : null}
                                                    </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                        colSpan={5}
                                        count={filteredGroups.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            inputProps: { 'aria-label': 'rows per page' },
                                            native: true,
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                </Paper>
            </div>
        );
    }
}

ManageGroupsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    groups: PropTypes.array.isRequired,
    setFilter: PropTypes.func
};

ManageGroupsTable.defaultProps = {
    groups: []
};

export default withStyles(styles)(ManageGroupsTable);
